import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface HomeSectionImage {
  id: string;
  section_key: string;
  image_url: string;
  alt_text: string | null;
  title: string | null;
  subtitle: string | null;
  link_url: string | null;
  display_order: number | null;
}

export const useHomeSectionImages = () => {
  return useQuery({
    queryKey: ["home-section-images"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("home_section_images")
        .select("*")
        .eq("active", true)
        .order("display_order", { ascending: true });

      if (error) throw error;
      return data as HomeSectionImage[];
    },
  });
};

export const useHomeSectionImage = (sectionKey: string) => {
  const { data, isLoading, error } = useHomeSectionImages();
  
  const image = data?.find((img) => img.section_key === sectionKey);
  
  return { data: image, isLoading, error };
};
